import { styled } from "@mui/material/styles";

export const ProductNavigationWrapper = styled("div")(({ theme }) => ({
    display: "none",
    gridArea: "navigation",
    [theme.breakpoints.up("md")]: {
        display: "block",
    },
}));

export const ProductNavigationContent = styled("div")({
    position: "sticky",
    top: 0,
});
